module.exports = __webpack_public_path__ + "img/sponsors-02.6c501c84.png";